import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        report: '=',
        comparisonReport: '=',
        questionCounter: '=',
        showAverages: '='
    },
    template: `
    <div class="items09">
        <h2 class="page-break">{{ 'report.Results by competency' | translate }}</h2>
        <div class="item"
            ng-repeat-start="category in vm.categoriesForm.categories"
            ng-init="comparisonCategory = vm.comparisonCategoriesForm.categories[$index]">
            <h3>{{ category.name }}</h3>
            <ul class="ticks">
                <!--NOTE: CURRENTLY ALL ELEMENTS HAVE SAME DISTANCE FROM ONE-ANOTHER (points value unused) -->
                <li ng-repeat="answer in vm.categoriesForm.answerOptions">{{ answer.label }}</li>
            </ul>
            <dl>
                <dt ng-repeat-start="role in vm.EVALUATION_ROLE_ENUM.KEYS">{{ vm.EVALUATION_ROLE_ENUM.LABELS[role] }}</dt>
                <dd ng-repeat-end>
                    <evaluation-public-report-partials-bar
                        average="category.roleAverages[role]"
                        count="vm.categoriesForm.answerOptions.length"
                        group-average="category.groupAveragesByRole[role]"
                        show-averages="vm.showAverages"
                        show-title="vm.comparisonReport!==undefined"
                        title="vm.report.groupName"
                    />
                    <evaluation-public-report-partials-bar
                        ng-if="comparisonCategory"
                        average="comparisonCategory.roleAverages[role]"
                        count="vm.comparisonCategoriesForm.answerOptions.length"
                        group-average="comparisonCategory.groupAveragesByRole[role]"
                        show-averages="vm.showAverages"
                        is-comparison="true"
                        title="vm.comparisonReport.groupName"
                    />
                </dd>
            </dl>
        </div>
        <div class="item"
            ng-repeat="question in category.questions"
            ng-init="comparisonQuestion = comparisonCategory.questions[$index]"
            ng-repeat-end>
            <evaluation-public-report-question-scale
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                show-averages="vm.showAverages"
                counter="vm.questionCounter[question.id]"
                question="question"
                comparison-question="comparisonQuestion"
                answers="vm.categoriesForm.answerOptions"
                title="vm.report.groupName"
                comparison-title="vm.comparisonReport.groupName"
            />
            <evaluation-public-report-question-text
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                question="question"
                counter="vm.questionCounter[question.id]"
                is-comparison="true"
            />
        </div>
    </div>
    `
})
export default class {
    constructor (lodash, EVALUATION_ROLE_ENUM, QUESTIONS_TYPE_ENUM) {
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.lodash = lodash;
    }

    $onInit () {
        this.categoriesForm = this.report.categoriesForm;
        this.comparisonCategoriesForm = this.lodash.get(this.comparisonReport, 'categoriesForm', {});
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/category/results/index.js